export default "__VITE_ASSET__DggZDule__"